angular.module("ainapp")
    .controller("ProcessedPDCController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {


            $scope.PageName = "Processed PDCs";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }



            $scope.Init = function () {

                $scope.Filter = {
                    PDCType: "Processed",
                    ChequeNo: "",
                    Type: "",
                    DateFrom: new Date(),
                    DateTo: new Date(),
                    CustomerIds: [],
                }

                $scope.Load = false;

            }
            $scope.Init();

            $scope.FilterData = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }

            $scope.ClearData = function () {
                $scope.Init();
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }

            $scope.customerSelectDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter != undefined) {
                            if (o.data.filter.filters.length > 0) {
                                MainService.AccountsInPDCAutoComplete(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success({
                                        Data: []
                                    });
                                    toastr.error("Network Error");
                                });
                            } else {
                                o.success({
                                    Data: []
                                });
                            }
                        } else {
                            o.success({
                                Data: []
                            });
                        }

                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 10
            };

            $scope.selectCustomerOptions = {
                placeholder: "Select Accounts...",
                dataTextField: "Name",
                dataValueField: "Id",
                valuePrimitive: true,
                autoBind: true,
                dataSource: $scope.customerSelectDataSource
            };


            $scope.KendoSource = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {

                        o.data.FromMonth = $scope.Filter.DateFrom.getMonth() + 1;
                        o.data.FromDay = $scope.Filter.DateFrom.getDate();
                        o.data.FromYear = $scope.Filter.DateFrom.getFullYear();

                        o.data.ToMonth = $scope.Filter.DateTo.getMonth() + 1;
                        o.data.ToDay = $scope.Filter.DateTo.getDate();
                        o.data.ToYear = $scope.Filter.DateTo.getFullYear();

                        o.data.DateFrom = $scope.Filter.DateFrom;
                        o.data.DateTo = $scope.Filter.DateTo;
                        o.data.PDCType = $scope.Filter.PDCType;
                        o.data.Type = $scope.Filter.Type;
                        o.data.ChequeNo = $scope.Filter.ChequeNo;
                        o.data.CustomerIds = $scope.Filter.CustomerIds;

                        MainService.PDCsInView(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error("NetworkError");
                        })
                    },

                },
                change: function (data) {},
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            Id: {
                                type: "number",
                                editable: false,
                            },
                            Amount: {
                                type: "number",
                                editable: false,
                            },
                            PDCNo: {
                                type: "string",
                                editable: false,
                            },
                            VoucherNo: {
                                type: "string",
                                editable: false,
                            },
                            Type: {
                                type: "string",
                                editable: false,
                            },
                            Status: {
                                type: "string",
                                editable: false,
                            },
                            Remarks: {
                                type: "string",
                                editable: false,
                            },
                            CustomerAccountName: {
                                type: "string",
                                editable: false,
                            },
                            BankAccountName: {
                                type: "string",
                                editable: false,
                            },
                            PDCAccountName: {
                                type: "string",
                                editable: false,
                            },
                            ChequeNo: {
                                type: "string",
                                editable: false,
                            },
                            ChequeName: {
                                type: "string",
                                editable: false,
                            },
                            ChequeDate: {
                                type: "date",
                                editable: false,
                            },
                            Date: {
                                type: "date",
                                editable: false,
                            },

                        }
                    }
                },
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
                pageSize: 20,
                aggregate: [
                    {
                        field: "Amount",
                        aggregate: "sum"
                        }
                    ],
            });

            $scope.KendoGridOptions = {
                editable: false,
                pageable: true,
                toolbar: ["excel"],
                height: 700,
                resizable: true,
                dataSource: $scope.KendoSource,
                pageSize: 20,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                sortable: true,
                scrollable: true,
                filterable: true,
                groupable: true,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },



                columns: [
                    {
                        field: "PDCNo",
                        title: "PDC No",
                        width: '120px'
                        },
                    {
                        field: "VoucherNo",
                        title: "Voucher No",
                        width: '120px'
                        },
                    {
                        field: "Type",
                        title: "Type",
                        width: '220px'
                        },
                    {
                        field: "ChequeNo",
                        title: "Cheque No",
                        width: '220px'
                        },
                    {
                        field: "ChequeName",
                        title: "Cheque Name",
                        width: '220px'
                    },
                    {
                        field: "Date",
                        title: "Date",
                        template: "#= kendo.toString(kendo.parseDate(Date, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        width: '120px'
                        },
                    {
                        field: "ChequeDate",
                        title: "Cheque Date",
                        template: "#= kendo.toString(kendo.parseDate(ChequeDate, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        width: '120px'
                        },
                    {
                        field: "Amount",
                        title: "Amount",
                        template: "<div style='text-align: right'>#=kendo.toString(Amount, 'n')#</div>",
                        width: '120px',
                        aggregates: ["sum"],
                        footerTemplate: "#=kendo.toString(sum, 'n')#",
                        },
                    {
                        field: "CustomerAccountName",
                        title: "Account",
                        width: '220px'
                        },
                    {
                        field: "BankAccountName",
                        title: "Bank Account ",
                        width: '220px'
                        },
                    {
                        field: "PDCAccountName",
                        title: "PDC Account",
                        width: '220px'
                        },
                    {
                        field: "Status",
                        title: "Status",
                        width: '120px'
                        },
                    {
                        field: "Remarks",
                        title: "Process Remarks",
                        width: '150px'
                        },
                          {
                        field: "Photo",
                        title: "Photo",
                        template:`<img ng-if="dataItem.Photo != null && dataItem.Photo != ''" src="{{basePath}}{{dataItem.Photo}}" width="100" height="40" />`,
                        width: '120px'
                    },
                    {
                        title: "Options",
                        template: "<button class=' btn-default btn-sm fa fa-undo'  ng-click='ReversePDC(dataItem)'></button></button><button class=' btn-default btn-sm fa fa-file'  ng-click=\"ViewGl(dataItem.Id, 'PDC')\"></button>  ",
                        width: '80px'
                        },
                    ],
            };

            $scope.SelectedData = {};
            $scope.ReversePDC = function (data) {
                $scope.SelectedData = data;
                $("#myModal2").modal("show");
            }

            $scope.ReverseWithConfirm = function () {
                $scope.Load = true;
                MainService.ReversePDC($scope.SelectedData).then(function (response) {
                    if (response.data) {
                        $('#myModal2').modal('hide');
                        toastr.success("Success");
                        $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                        $scope.SelectedDataForDelete = {};
                    } else {
                        toastr.error("failed");
                    }
                    $scope.Load = false;
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.Load = false;
                });
            }


        }])
